// extracted by mini-css-extract-plugin
export default {"sesion":"Login_sesion__qAPPS","header":"Login_header__AvOpm","content":"Login_content__k2i+F"};